import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaCalendarAlt, FaSearch, FaChevronRight, FaRegClock } from "react-icons/fa";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "../components/Header";
import Footer from "../components/Footer";

// Articles d'actualité (normalement, ces données viendraient d'une API)
const NewsArticles = [
  {
    id: 2,
    title: "Lancement Officiel : CINEF-EXPERTISE COMPTABLE Ouvre ses Portes pour Accompagner la Croissance des Entreprises au Bénin",
    excerpt: "Une nouvelle ère de conseil et d'accompagnement pour les entreprises béninoises et de la sous-région s'ouvre aujourd'hui. Le cabinet CINEF-EXPERTISE COMPTABLE annonce avec enthousiasme le lancement officiel de ses activités.",
    content: "Contenu détaillé de l'article sur la réforme fiscale...",
    image: "/assets/images/Actu1.jpg",
    category: "Fiscalité",
    date: "24 Septembre 2025",
    author: "Wilfrid DEDJI",
    readTime: "8 min",
    featured: true,
  },
  {
    id: 1,
    title: "Le SIMA 2025 : Le rythme de la croissance - L'Expert-Comptable, l'architecte financier de l'industrie musicale africaine",
    excerpt: "Le Salon des Industries Musicales d'Afrique Francophone s'apprête à faire vibrer Cotonou du 10 au 15 novembre. Découvrez pourquoi cet événement représente une opportunité stratégique majeure pour les experts-comptables.",
    content: "Contenu détaillé de l'article sur l'expansion...",
    image: "/assets/images/image29.jpg",
    category: "Entreprise",
    date: "24 Septembre 2025",
    author: "Marie Laurent",
    readTime: "3 min",
    featured: true,
  },
  {
    id: 3,
    title: "Décryptage de la Loi 2026-01 : La révolution de l'industrie du cinéma et de l'image animée au Bénin",
    excerpt: "Promulguée le 03 février 2026, la loi n° 2026-01 marque un tournant décisif pour le cinéma béninois. Elle vise à transformer un secteur jusqu'ici artisanal en une véritable industrie de l'écran, capable de générer de la valeur et de rayonner à l'international.",
    content: "Contenu détaillé de l'article sur la loi cinéma...",
    image: "/assets/images/loi_cine.jpg",
    category: "Actualités",
    date: "30 juin 2026",
    author: "CINEF-EC",
    readTime: "6 min",
    featured: true,
  },
  {
    id: 4,
    title: "Cliniques et cabinets privés au Bénin : sécurité des soins, gouvernance et risques financiers sous le nouveau cadre légal",
    excerpt: "Le nouveau cadre légal pour les cliniques et cabinets privés au Bénin met l'accent sur la sécurité des soins, la gouvernance et la gestion des risques financiers. Découvrez les implications pour les professionnels de santé et les investisseurs.",
    content: "Contenu détaillé de l'article sur la sécurité des soins et la gouvernance dans les cliniques et cabinets privés au Bénin...",
    image: "/assets/images/actu-sante-conformite.png",
    category: "Actualités",
    date: "31 Août 2026",
    author: "CINEF-EC",
    readTime: "30 min",
    featured: true,
  },
  {
    id: 5,
    title: "Établissements privés de santé au Bénin : du cadre de 1997 à la réforme stratégique de 2025-2026",
    excerpt: "Le secteur de la santé privée au Bénin connaît une mutation juridique et économique majeure.",
    content: "Contenu détaillé de l'article sur la mutation juridique et économique du secteur de la santé privée au Bénin...",
    image: "/assets/images/actu-sante-reforme-1997-2026.png",
    category: "Actualités",
    date: "31 Août 2026 ",
    author: "CINEF-EC",
    readTime: "30 min",
    featured: true,
  },
  {
    id: 6,
    title: "Secteur de la santé privée au Bénin : nouveaux enjeux juridiques, financiers et opérationnels pour les promoteurs et praticiens",
    excerpt: "Le secteur de la santé privée au Bénin est confronté à de nouveaux enjeux juridiques, financiers et opérationnels pour les promoteurs et praticiens.",
    content: "Contenu détaillé de l'article sur les nouveaux enjeux juridiques, financiers et opérationnels pour les promoteurs et praticiens dans le secteur de la santé privée au Bénin...",
    image: "/assets/images/actu-sante-enjeux-strategiques.png",
    category: "Actualités",
    date: "31 Août 2026",
    author: "CINEF-EC",
    readTime: "30 min",
    featured: true,
  },
];

// Catégories pour le filtre
const Categories = [
  "Toutes", "Fiscalité", "Comptabilité", "Entreprise", "Événement", "RSE", "Actualités",
];

const Actualites = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("Toutes");
  const [filteredArticles, setFilteredArticles] = useState(NewsArticles);
  const [featuredArticles, setFeaturedArticles] = useState([]);
  const [articlesPerPage, setArticlesPerPage] = useState(6);

  useEffect(() => {
    const sections = document.querySelectorAll(".animate-on-scroll");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate");
          }
        });
      },
      { threshold: 0.2 }
    );
    sections.forEach((section) => observer.observe(section));
    setFeaturedArticles(NewsArticles.filter((article) => article.featured));
    return () => sections.forEach((section) => observer.unobserve(section));
  }, []);

  useEffect(() => {
    const filtered = NewsArticles.filter((article) => {
      const matchesSearch =
        article.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        article.excerpt.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesCategory =
        selectedCategory === "Toutes" || article.category === selectedCategory;
      return matchesSearch && matchesCategory;
    });
    setFilteredArticles(filtered);
  }, [searchTerm, selectedCategory]);

  const nonFeaturedArticles = filteredArticles.filter((a) => !a.featured);

  const loadMoreArticles = () => {
    setArticlesPerPage((prev) => prev + 3);
  };

  return (
    <>
      <Header />

      {/* Hero */}
      <div className="hero-section">
        <div className="hero-content">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <motion.div
                  initial={{ opacity: 0, x: -50 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8 }}
                  className="hero-text"
                >
                  <h1 className="hero-title">
                    <span className="hero-subtitle">Expertise & Perspectives</span>
                    <span className="main-title">
                      Actualités <span className="text-gradient">CINEF-EC</span>
                    </span>
                  </h1>
                  <p className="hero-desc">
                    Décryptage des dernières évolutions en matière fiscale, comptable et financière
                  </p>
                  <div className="hero-actions">
                    <div className="hero-category-tags">
                      {Categories.slice(1, 4).map((category, index) => (
                        <button
                          key={index}
                          className="hero-tag"
                          onClick={() => setSelectedCategory(category)}
                        >
                          #{category}
                        </button>
                      ))}
                    </div>
                  </div>
                </motion.div>
              </div>
              <div className="col-lg-6">
                <motion.div
                  className="hero-images"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 1, delay: 0.2 }}
                >
                  <motion.div
                    className="news-card news-card-1"
                    animate={{ y: [0, -10, 0] }}
                    transition={{ duration: 4, repeat: Infinity, repeatType: "reverse" }}
                  >
                    <img src="../assets/images/image6.png" alt="Actualité fiscale" />
                    <div className="news-card-content">
                      <span className="news-tag">Fiscalité</span>
                      <h3>Réforme fiscale 2025</h3>
                    </div>
                  </motion.div>
                  <motion.div
                    className="news-card news-card-2"
                    animate={{ y: [0, 10, 0] }}
                    transition={{ duration: 5, repeat: Infinity, repeatType: "reverse", delay: 0.5 }}
                  >
                    <img src="../assets/images/image2.png" alt="Actualité comptable" />
                    <div className="news-card-content">
                      <span className="news-tag">Comptabilité</span>
                      <h3>Guide comptable TPE</h3>
                    </div>
                  </motion.div>
                  <motion.div
                    className="news-card news-card-3"
                    animate={{ y: [0, -8, 0] }}
                    transition={{ duration: 4.5, repeat: Infinity, repeatType: "reverse", delay: 1 }}
                  >
                    <img src="../assets/images/image4.png" alt="Expansion" />
                    <div className="news-card-content">
                      <span className="news-tag">Entreprise</span>
                      <h3>N'hésitez pas à nous contacter</h3>
                    </div>
                  </motion.div>
                </motion.div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section Articles à la Une */}
      <section className="featured-news-section">
        <div className="container">
          <motion.h2
            className="section-title mb-5"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span className="highlight">À la Une</span>
          </motion.h2>

          <div className="row">
            {featuredArticles.map((article, index) => (
              <motion.div
                key={article.id}
                className="col-md-6 mb-4"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
              >
                <Link to={`/actualites/${article.id}`} className="featured-article-card">
                  <div className="card border-0 h-100">
                    <div className="position-relative">
                      <img
                        src={article.image}
                        className="card-img-top"
                        alt={article.title}
                        style={{ height: "250px", objectFit: "cover" }}
                      />
                      <span className="category-badge">{article.category}</span>
                    </div>
                    <div className="card-body">
                      <div className="d-flex align-items-center mb-3">
                        <FaCalendarAlt className="text-muted me-2" size={14} />
                        <small className="text-muted">{article.date}</small>
                        <div className="ms-3 d-flex align-items-center">
                          <FaRegClock className="text-muted me-2" size={14} />
                          <small className="text-muted">{article.readTime}</small>
                        </div>
                      </div>
                      <h3 className="card-title h4">{article.title}</h3>
                      <p className="card-text text-muted">{article.excerpt}</p>
                      <div className="read-more">
                        Lire l'article <FaChevronRight size={12} className="ms-1" />
                      </div>
                    </div>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Section Tous les Articles */}
      {nonFeaturedArticles.length > 0 && (
        <section className="news-list-section">
          <div className="container">
            <motion.h2
              className="section-title mb-5"
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <span className="highlight">Tous nos articles</span>
            </motion.h2>

            {/* Barre de recherche et filtre catégorie */}
            <div className="row mb-5">
              <div className="col-md-6 mb-3 mb-md-0">
                <div className="search-container">
                  <FaSearch className="search-icon" />
                  <input
                    type="text"
                    className="form-control search-input"
                    placeholder="Rechercher un article..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="categories-container d-flex flex-wrap">
                  {Categories.map((category, index) => (
                    <button
                      key={index}
                      className={`category-btn ${selectedCategory === category ? "active" : ""}`}
                      onClick={() => setSelectedCategory(category)}
                    >
                      {category}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            <div className="row">
              {nonFeaturedArticles.slice(0, articlesPerPage).map((article, index) => (
                <motion.div
                  key={article.id}
                  className="col-md-6 col-lg-4 mb-4"
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: (index % 6) * 0.1 }}
                >
                  <Link to={`/actualites/${article.id}`} className="article-card">
                    <div className="card border-0 h-100 shadow-sm">
                      <div className="position-relative">
                        <img
                          src={article.image}
                          className="card-img-top"
                          alt={article.title}
                          style={{ height: "200px", objectFit: "cover" }}
                        />
                        <span className="category-badge">{article.category}</span>
                      </div>
                      <div className="card-body">
                        <div className="d-flex align-items-center mb-2">
                          <FaCalendarAlt className="text-muted me-2" size={12} />
                          <small className="text-muted">{article.date}</small>
                          <div className="ms-3 d-flex align-items-center">
                            <FaRegClock className="text-muted me-2" size={12} />
                            <small className="text-muted">{article.readTime}</small>
                          </div>
                        </div>
                        <h3 className="card-title h5">{article.title}</h3>
                        <p className="card-text small text-muted">{article.excerpt}</p>
                        <div className="read-more small">
                          Lire l'article <FaChevronRight size={10} className="ms-1" />
                        </div>
                      </div>
                    </div>
                  </Link>
                </motion.div>
              ))}
            </div>

            {articlesPerPage < nonFeaturedArticles.length && (
              <div className="text-center mt-4 mb-5">
                <button
                  className="btn btn-outline-primary load-more-btn"
                  onClick={loadMoreArticles}
                >
                  Voir plus d'articles
                </button>
              </div>
            )}

            {nonFeaturedArticles.length === 0 && (
              <div className="text-center py-5">
                <p className="text-muted fs-5">Aucun article trouvé pour cette recherche.</p>
              </div>
            )}
          </div>
        </section>
      )}

      <Footer />

      <style>
        {`
          /* HERO */
          .hero-section {
            position: relative;
            background: linear-gradient(135deg, #dc3545 0%, #198754 100%);
            color: white;
            padding: 120px 0 0;
            overflow: hidden;
          }
          .hero-content { position: relative; z-index: 2; }
          .hero-text { padding-bottom: 60px; }
          .hero-title { display: flex; flex-direction: column; margin-bottom: 25px; }
          .hero-subtitle {
            font-size: 18px;
            font-weight: 500;
            text-transform: uppercase;
            letter-spacing: 2px;
            margin-bottom: 15px;
            color: rgba(255,255,255,0.8);
          }
          .main-title { font-size: 48px; font-weight: 800; line-height: 1.1; }
          .text-gradient {
            background: linear-gradient(to right, #fff, rgba(255,255,255,0.7));
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }
          .hero-desc { font-size: 18px; margin-bottom: 30px; opacity: 0.9; max-width: 90%; }
          .hero-actions { display: flex; flex-direction: column; gap: 15px; max-width: 450px; }
          .hero-category-tags { display: flex; flex-wrap: wrap; gap: 10px; }
          .hero-tag {
            background: rgba(255,255,255,0.15);
            border: 1px solid rgba(255,255,255,0.3);
            color: white;
            padding: 6px 16px;
            border-radius: 20px;
            font-size: 14px;
            cursor: pointer;
            transition: all 0.3s ease;
          }
          .hero-tag:hover { background: rgba(255,255,255,0.25); }

          .hero-images { position: relative; height: 400px; }
          .news-card {
            position: absolute;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 15px 35px rgba(0,0,0,0.2);
            width: 250px;
            height: 180px;
          }
          .news-card img { width: 100%; height: 100%; object-fit: cover; }
          .news-card-content {
            position: absolute;
            bottom: 0; left: 0;
            width: 100%;
            padding: 15px;
            background: linear-gradient(to top, rgba(0,0,0,0.8), transparent);
          }
          .news-tag {
            display: inline-block;
            padding: 3px 10px;
            background: linear-gradient(to right, #dc3545, #198754);
            border-radius: 20px;
            font-size: 12px;
            font-weight: 600;
            margin-bottom: 8px;
            color: white;
          }
          .news-card-content h3 { font-size: 14px; margin: 0; color: white; }
          .news-card-1 { top: 20px; left: 30px; z-index: 3; transform: rotate(-5deg); }
          .news-card-2 { top: 60px; right: 20px; z-index: 2; transform: rotate(5deg); }
          .news-card-3 { bottom: 40px; left: 80px; z-index: 1; transform: rotate(2deg); }

          /* SECTION TITLES */
          .section-title {
            font-size: 32px;
            font-weight: bold;
            position: relative;
            display: inline-block;
            margin-bottom: 50px;
          }
          .section-title::after {
            content: '';
            position: absolute;
            bottom: -15px; left: 0;
            width: 60px; height: 4px;
            background: linear-gradient(to right, #dc3545, #198754);
            border-radius: 2px;
          }
          .highlight { color: #dc3545; }

          /* FEATURED SECTION */
          .featured-news-section {
            padding: 100px 0 80px;
            background-color: #f8f9fa;
            position: relative;
          }
          .featured-news-section::before {
            content: '';
            position: absolute;
            inset: 0;
            background-image:
              radial-gradient(circle at 20% 30%, rgba(220,53,69,0.03) 0%, transparent 400px),
              radial-gradient(circle at 80% 70%, rgba(25,135,84,0.03) 0%, transparent 400px);
          }
          .featured-article-card {
            text-decoration: none;
            color: inherit;
            display: block;
            transition: transform 0.3s ease;
          }
          .featured-article-card:hover { transform: translateY(-5px); }
          .featured-article-card .card {
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 10px 30px rgba(0,0,0,0.08);
          }

          /* CATEGORY BADGE */
          .category-badge {
            position: absolute;
            top: 15px; right: 15px;
            background: linear-gradient(to right, #dc3545, #198754);
            color: white;
            padding: 5px 15px;
            border-radius: 30px;
            font-size: 12px;
            font-weight: 600;
          }

          .read-more {
            color: #dc3545;
            font-weight: 600;
            font-size: 14px;
            display: flex;
            align-items: center;
            margin-top: 15px;
          }

          /* ALL ARTICLES SECTION */
          .news-list-section {
            padding: 80px 0 60px;
            background-color: white;
          }

          /* SEARCH */
          .search-container { position: relative; }
          .search-icon {
            position: absolute;
            top: 50%; left: 15px;
            transform: translateY(-50%);
            color: #6c757d;
            z-index: 1;
          }
          .search-input {
            padding-left: 42px;
            height: 48px;
            border-radius: 30px;
            border: 1.5px solid #ddd;
            font-size: 14px;
            transition: border-color 0.3s;
          }
          .search-input:focus {
            border-color: #dc3545;
            box-shadow: 0 0 0 3px rgba(220,53,69,0.1);
            outline: none;
          }

          /* CATEGORY FILTER */
          .categories-container { display: flex; flex-wrap: wrap; gap: 8px; }
          .category-btn {
            border: 1.5px solid #e0e0e0;
            background-color: #fff;
            color: #555;
            padding: 7px 16px;
            border-radius: 20px;
            font-size: 13px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.3s ease;
          }
          .category-btn:hover { border-color: #dc3545; color: #dc3545; }
          .category-btn.active {
            background: linear-gradient(to right, #dc3545, #198754);
            color: white;
            border-color: transparent;
          }

          /* ARTICLE CARDS */
          .article-card {
            text-decoration: none;
            color: inherit;
            display: block;
            transition: transform 0.3s ease;
          }
          .article-card:hover { transform: translateY(-5px); }
          .article-card .card {
            border-radius: 12px;
            overflow: hidden;
            transition: box-shadow 0.3s ease;
          }
          .article-card:hover .card { box-shadow: 0 12px 30px rgba(0,0,0,0.12) !important; }

          /* LOAD MORE */
          .load-more-btn {
            border-radius: 30px;
            padding: 10px 35px;
            border-color: #dc3545;
            color: #dc3545;
            font-weight: 600;
            transition: all 0.3s ease;
          }
          .load-more-btn:hover {
            background-color: #dc3545;
            border-color: #dc3545;
            color: white;
          }

          /* RESPONSIVE */
          @media (max-width: 992px) {
            .hero-section { padding: 80px 0 0; }
            .main-title { font-size: 40px; }
            .news-card { width: 220px; height: 160px; }
            .hero-images { height: 350px; margin-top: 40px; }
          }
          @media (max-width: 768px) {
            .hero-section { padding: 60px 0 0; }
            .hero-text { text-align: center; padding-bottom: 40px; }
            .hero-desc { margin: 0 auto 30px; }
            .hero-actions { margin: 0 auto; }
            .hero-category-tags { justify-content: center; }
            .news-card {
              position: relative;
              margin: 10px auto;
              width: 80%;
              max-width: 280px;
              height: 180px;
              transform: none !important;
              top: auto; left: auto; right: auto; bottom: auto;
            }
            .hero-images {
              height: auto;
              display: flex;
              flex-direction: column;
              gap: 20px;
              margin-bottom: 40px;
            }
            .featured-news-section { padding: 60px 0 40px; }
            .news-list-section { padding: 50px 0 40px; }
          }
        `}
      </style>
    </>
  );
};

export default Actualites;